<template>
  <li class="my-px">
    <o-panel-link
      class="flex flex-row items-center h-10 rounded-lg text-gray-300 relative -mx-1 hover:bg-white hover:bg-opacity-15 transition-colors cursor-pointer"
      :class="[
        active ? 'bg-white bg-opacity-15' : '',
        collapse ? 'px-3' : 'px-4',
      ]"
      path="/alerts"
    >
      <div class="w-full flex items-center">
        <span v-if="!collapse && active" class="block h-full w-3 left-0 absolute p-1">
          <span class="block w-full h-full bg-primary rounded-full" />
        </span>

        <span
          class="flex items-center justify-center text-lg text-gray-400"
          :class="[
            collapse ? '-ml-px' : '',
            notifications.length ? 'animate-ring' : ''
          ]"
        >
          <o-icon
            icon="menuAlerts"
            :size="18"
          />
        </span>
        <span class="ml-5 text-sm" :class="[ collapse? 'sm:hidden' : '']">Alerts</span>
      </div>

      <div
        class="flex items-center space-x-1"
        :class="[
          collapse ? 'absolute top-0 right-0' : '',
        ]"
      >
        <div v-if="counts && counts.unread" class="-mr-1 px-2 py-1 bg-red-600 text-white rounded-lg text-xs">
          {{ Number(counts.unread) }}
        </div>
      </div>
    </o-panel-link>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

import * as API from '~/api'

export default {
  data () {
    return {
      counts: null
    }
  },
  computed: {
    ...mapGetters({
      collapse: 'menu'
    }),
    active () {
      return this.$route.hash === '#/alerts'
    },
    notifications () {
      return this.$auth.info?.panels || []
    }
  },
  mounted () {
    this.fetchAlertCounts()
  },
  methods: {
    async fetchAlertCounts () {
      try {
        const response = await API.Alert.counts()

        if (response) {
          this.counts = response
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}

</script>
